import React, { DetailedHTMLProps, HTMLProps } from 'react'
import { useSiteMetadata } from '../hooks/use-site-metadata'
import * as styles from '../styles/components/footer.module.scss'
import cx from 'classnames'
import { showPreferences } from 'vanilla-cookieconsent'

export type FooterProps = DetailedHTMLProps<HTMLProps<HTMLDivElement>, HTMLDivElement>

const Footer = ({ className, ...rest }: FooterProps) => {
    const { companyName, socialLinks } = useSiteMetadata()
    const currentYear = new Date().getFullYear()

    return (
        <div className={cx(styles.container, className)} {...rest}>
            <div className={styles.copyrightStatement}>
                {`Copyright ${companyName} ${currentYear}`}
            </div>
            <div className={styles.footerLinks}>
                <div>
                    <a href={'/privacy-notice/'}>Privacy notice</a>
                </div>
                <div>
                    <button
                        aria-label="Open cookie consent settings"
                        onClick={() => showPreferences()}
                        className={styles.cookieConsent}
                    >
                        Cookies
                    </button>
                </div>
            </div>
            <div className={styles.socialLinks}>
                {socialLinks?.map((item) =>
                    <a href={item.url} className={styles.socialLink} key={item.name}>{item.name}</a>,
                )}
            </div>
        </div>
    )
}

export default Footer
